/**
 * Copyright Aquera Inc 2025
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

export const styles = css`
  :host {
    --min-width: 180px;
    display: grid;
    grid-template-rows: auto;
    overflow: auto;
    inline-size: 100%;
    position: relative;
    box-sizing: border-box;
    border: 1px solid var(--nile-colors-neutral-400, , var(--ng-colors-border-secondary));
    border-radius: var(--nile-radius-md, var(--ng-radius-xl));
    background-color: var(--nile-colors-white-base, var(--ng-colors-bg-primary));
    max-height: 100%;
    width: 100%;
    min-width: var(--min-width);
    box-shadow: var(--nile-box-shadow-3, var(--ng-shadow-xs));
  }

  ::slotted(nile-grid-head),
  ::slotted(nile-grid-body) {
    inline-size: 100%;
  }

  .nile-resize-start,
  .nile-resize-end {
    position: absolute;
    z-index: 4;
    background-color: var(--nile-colors-neutral-400, var(--ng-colors-border-secondary));
    width: 2px;
    height: 100%;
    top: 0;
    display: none;
    bottom: 0;
  }
`;

export default [styles];
